import React, { useEffect, useState } from "react";
import Select from "react-select";
import { Controller } from "react-hook-form";
import { getProductsLi } from "../../../services/Settings/dropdown";

function ucfirst(str) {
  var firstLetter = str.substr(0, 1);
  return firstLetter.toUpperCase() + str.substr(1);
}

const EstProductsLi = ({
  control,
  name,
  onSelectChange,
  target,
  placeholder = "Select",
  selectedProduct,
  index,
  disabled,
  dropView,
  groupType,
  onCreate,
  showCreateOption = false,
  refreshKey,
  showDescription =false
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [fetchResponse, setFetchResponse] = useState([]);

  const loadOptions = async () => {
    setIsLoading(true);
    try {
      const data = await getProductsLi(groupType);
      const response = data?.data?.map(dta => ({
        label: showDescription
        ? `${dta?.product_code || ""} - ${dta?.description || ""}` 
        : `${dta?.product_code || ""}`, 
      value: dta.id,
      ...dta,
    })) || [];

      let options = [...response];
      
      // Filter out already selected products if index is provided
      if (index > 0 && selectedProduct) {
        const usedPayroll = selectedProduct.map(
          dt => dt?.product_id?.id != "" && dt?.product_id?.id
        );
        options = options.filter(item1 => {
          return !usedPayroll?.some(item2 => item2 === item1.value);
        });
      }

      // Add create option if enabled
      if (showCreateOption && onCreate) {
        options.unshift({
          label: "Create",
          value: "create",
          isCreateButton: true,
        });
      }

      setFetchResponse(options);
    } catch (error) {
      console.error("Error fetching product list:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadOptions();
  }, [groupType, refreshKey]); // Add refreshKey to dependencies

  return (
    <div>
      <Controller
        name={name}
        control={control}
        defaultValue={null}
        render={({ field: { onChange, ref, value } }) => (
          <Select
            options={fetchResponse}
            // placeholder={placeholder}
            placeholder={
              <div className="css-placeholder">
                {placeholder || "Select"} 
              </div>
            }
            isLoading={isLoading}
            inputRef={ref}
            onChange={(selected) => {
              if (selected?.isCreateButton) {
                onCreate(); // Trigger the create function
              } else {
                onChange(selected);
                if (onSelectChange) onSelectChange(selected);
              }
            }}
            isDisabled={disabled}
            value={value}
            classNamePrefix="react-select"
            className="elevate-dropdown"
            menuPortalTarget={document.body}
            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
            menuPlacement={dropView ? "top" : "bottom"}
          />
        )}
      />
    </div>
  );
};

export default EstProductsLi;